import { Component, OnDestroy } from '@angular/core';
import { catchError, EMPTY, exhaustMap, interval } from 'rxjs';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-realtime-kpis',
  templateUrl: './realtime-kpis.component.html',
  styleUrl: './realtime-kpis.component.scss',
})
export class RealtimeKpisComponent implements OnDestroy {
  subscriptions = [];
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.realTimeLast30mTotals$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('realTimeLast30mTotals');
    });
    this.getChartData();

    this.subscriptions.push(
      interval(10000)
        .pipe(
          // Nächster Abruf erst, wenn der letzte zurück ist.
          exhaustMap(() =>
            this.analyticsService.getRealTimeLast30mTotals().pipe(catchError(() => EMPTY))
          )
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  getChartData() {
    this.analyticsService.getRealTimeLast30mTotals().subscribe();
  }

  get data() {
    return this.analyticsService.realTimeLast30mTotals$.value;
  }
}
